import { usePvData } from "@inrange/building-manager-api-client";
import Table from "react-bootstrap/Table";
import Loading from "../Loading";

const PVSummary: React.FC = () => {
  const isProd =
    import.meta.env.VITE_BRANCH_NAME === "main" &&
    !!import.meta.env.PROD &&
    !import.meta.env.VITE_TEST_MODE;
  const { fetchPVData } = usePvData();

  if (!isProd) {
    return <div>PV data summary not enabled in non-prod</div>;
  }
  if (fetchPVData.isLoading) {
    return <Loading label="Loading PV data summary..." height={"auto"} />;
  }
  if (fetchPVData.isError) {
    return (
      <div style={{ color: "red" }}>Error loading the PV data summary.</div>
    );
  }

  const summary = fetchPVData.data?.summary || {
    sites_verified: 0,
    zero_panels: [],
    map_render_failed: [],
    below_bounds: [],
    above_bounds: [],
  };

  const numSitesVerified: number = summary.sites_verified;
  const numOfSitesWithZeroPanels: number = summary.zero_panels?.length || 0;
  const mapRenderFailed: number = summary.map_render_failed?.length || 0;

  const belowBounds: number = summary.below_bounds?.length || 0;
  const aboveBounds: number = summary.above_bounds?.length || 0;

  const numOfSitesOutOfBounds: number = belowBounds + aboveBounds;

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>No. with 0 panels</th>
            <th>% of sites out of bounds</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{numOfSitesWithZeroPanels + mapRenderFailed}</td>
            <td>
              {((numOfSitesOutOfBounds / numSitesVerified) * 100).toFixed(3)}%
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default PVSummary;
